import { ref, computed, nextTick } from "vue";
import { defineStore } from "pinia";
import { useToastsStore } from "@/store/toasts";
import { useRuntimeStore } from '@/store/runtime'



const filePacks = ref([
    {
        id: "lures",
        type: "lures",
        group_required: null,
        title: "Richiami",
        description: "Files sonori con registrazioni di uccelli",
        icon: "mdi-bird",
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        downloadTotal: 231581241, // somm als -ltr
        files: [
            {
                url: "/files/lures/allocco_comune.mp3",
                cached: false,
            },
            {
                url: "/files/lures/allodola_comune.mp3",
                cached: false,
            },
            {
                url: "/files/lures/aquila_reale.mp3",
                cached: false,
            },
            {
                url: "/files/lures/astore.mp3",
                cached: false,
            },
            {
                url: "/files/lures/averla_piccola.mp3",
                cached: false,
            },
            {
                url: "/files/lures/balia_nera.mp3",
                cached: false,
            },
            {
                url: "/files/lures/ballerina_bianca.mp3",
                cached: false,
            },
            {
                url: "/files/lures/ballerina_gialla.mp3",
                cached: false,
            },
            {
                url: "/files/lures/beccaccia.mp3",
                cached: false,
            },
            {
                url: "/files/lures/beccafico.mp3",
                cached: false,
            },
            {
                url: "/files/lures/beccofrusone.mp3",
                cached: false,
            },
            {
                url: "/files/lures/biancone.mp3",
                cached: false,
            },
            {
                url: "/files/lures/bigia_grossa.mp3",
                cached: false,
            },
            {
                url: "/files/lures/bigiarella.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cannaiola_verdognola.mp3",
                cached: false,
            },
            {
                url: "/files/lures/capinera.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cardellino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cesena.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cincia_bigia.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cincia_bigia_alpestre.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cincia_dal_ciuffo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cincia_mora.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cinciallegra.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cinciarella.mp3",
                cached: false,
            },
            {
                url: "/files/lures/ciuffolotto.mp3",
                cached: false,
            },
            {
                url: "/files/lures/civetta_capogrosso.mp3",
                cached: false,
            },
            {
                url: "/files/lures/civetta_nana-1.mp3",
                cached: false,
            },
            {
                url: "/files/lures/civetta_nana.mp3",
                cached: false,
            },
            {
                url: "/files/lures/codibugnolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/codirosso_comune.mp3",
                cached: false,
            },
            {
                url: "/files/lures/codirosso_spazzacamino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/codirossone.mp3",
                cached: false,
            },
            {
                url: "/files/lures/colombaccio.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cornacchia_nera.mp3",
                cached: false,
            },
            {
                url: "/files/lures/corvo_imperiale.mp3",
                cached: false,
            },
            {
                url: "/files/lures/coturnice.mp3",
                cached: false,
            },
            {
                url: "/files/lures/crociere.mp3",
                cached: false,
            },
            {
                url: "/files/lures/cuculo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/culbianco.mp3",
                cached: false,
            },
            {
                url: "/files/lures/falco_pecchiaiolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/falco_pellegrino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/fanello.mp3",
                cached: false,
            },
            {
                url: "/files/lures/fiorrancino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/francolino_di_monte.mp3",
                cached: false,
            },
            {
                url: "/files/lures/fringuello_alpino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/fringuello_comune.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gallo_cedrone.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gallo_forcello.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gheppio.mp3",
                cached: false,
            },
            {
                url: "/files/lures/ghiandaia.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gipeto.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gracchio_alpino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gracchio_corallino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gufo_comune.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gufo_reale-a.mp3",
                cached: false,
            },
            {
                url: "/files/lures/gufo_reale-b.mp3",
                cached: false,
            },
            {
                url: "/files/lures/lucherino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/luì_bianco.mp3",
                cached: false,
            },
            {
                url: "/files/lures/luì_piccolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/luì_verde.mp3",
                cached: false,
            },
            {
                url: "/files/lures/merlo_aquaiolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/merlo_comune.mp3",
                cached: false,
            },
            {
                url: "/files/lures/merlo_dal_collare.mp3",
                cached: false,
            },
            {
                url: "/files/lures/nibbio_bruno.mp3",
                cached: false,
            },
            {
                url: "/files/lures/nibbio_reale.mp3",
                cached: false,
            },
            {
                url: "/files/lures/nocciolaia.mp3",
                cached: false,
            },
            {
                url: "/files/lures/organetto.mp3",
                cached: false,
            },
            {
                url: "/files/lures/ortolano.mp3",
                cached: false,
            },
            {
                url: "/files/lures/passera_mattugia.mp3",
                cached: false,
            },
            {
                url: "/files/lures/passera_scopaiola.mp3",
                cached: false,
            },
            {
                url: "/files/lures/peppola.mp3",
                cached: false,
            },
            {
                url: "/files/lures/pernice_bianca.mp3",
                cached: false,
            },
            {
                url: "/files/lures/pettirosso.mp3",
                cached: false,
            },
            {
                url: "/files/lures/picchio_muraiolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/picchio_muratore.mp3",
                cached: false,
            },
            {
                url: "/files/lures/picchio_nero.mp3",
                cached: false,
            },
            {
                url: "/files/lures/picchio_rosso_maggiore.mp3",
                cached: false,
            },
            {
                url: "/files/lures/picchio_tridattilo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/picchio_verde.mp3",
                cached: false,
            },
            {
                url: "/files/lures/pigliamosche.mp3",
                cached: false,
            },
            {
                url: "/files/lures/poiana.mp3",
                cached: false,
            },
            {
                url: "/files/lures/prispolone.mp3",
                cached: false,
            },
            {
                url: "/files/lures/rampichino_alpestre.mp3",
                cached: false,
            },
            {
                url: "/files/lures/rampichino_comune.mp3",
                cached: false,
            },
            {
                url: "/files/lures/regolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/rigogolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/rondine_montana.mp3",
                cached: false,
            },
            {
                url: "/files/lures/rondone_alpino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/scricciolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/sordone.mp3",
                cached: false,
            },
            {
                url: "/files/lures/sparviere.mp3",
                cached: false,
            },
            {
                url: "/files/lures/spioncello.mp3",
                cached: false,
            },
            {
                url: "/files/lures/sterpazzola.mp3",
                cached: false,
            },
            {
                url: "/files/lures/stiaccino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/storno.mp3",
                cached: false,
            },
            {
                url: "/files/lures/succiacapre.mp3",
                cached: false,
            },
            {
                url: "/files/lures/torcicollo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/tordela.mp3",
                cached: false,
            },
            {
                url: "/files/lures/tordo_bottaccio.mp3",
                cached: false,
            },
            {
                url: "/files/lures/tordo_sassello.mp3",
                cached: false,
            },
            {
                url: "/files/lures/tottavilla.mp3",
                cached: false,
            },
            {
                url: "/files/lures/upupa.mp3",
                cached: false,
            },
            {
                url: "/files/lures/usignolo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/venturone.mp3",
                cached: false,
            },
            {
                url: "/files/lures/verdone.mp3",
                cached: false,
            },
            {
                url: "/files/lures/verzellino.mp3",
                cached: false,
            },
            {
                url: "/files/lures/zigolo_giallo.mp3",
                cached: false,
            },
            {
                url: "/files/lures/zigolo_muciatto.mp3",
                cached: false,
            },
            {
                url: "/files/lures/zigolo_nero.mp3",
                cached: false,
            }
        ]
    },

    // MBTILES

    /*

    {
        id: "pngp-ortofoto-1-17",
        group_required: null,
        type: "mbtiles-single-file",
        title: "Ortofoto PNGP (mbtiles)",
        description: "Mappa ortofoto PNGP (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 380482560,
        cached: false,
        status: "cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pngp-ortofoto-1-17",
                title: "Ortofoto PNGP (mbtiles)",
                url: "/files/mbtiles/pngp-ortofoto-1-17.mbtiles",
                type: "mbtiles-single-file",
                extent: [
                    781934.9806508283363655,    // 3857
                    5679667.4050984131172299,
                    848558.3316170207690448,
                    5734497.0189472911879420,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },

    {
        id: "vda-ortofoto-1-17",
        group_required: "ufficio_botanico",
        type: "mbtiles-single-file",
        title: "Ortofoto VdA (mbtiles)",
        description: "Mappa ortofoto VdA (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 1450550272,
        cached: false,
        status: "cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "vda-ortofoto-1-17",
                title: "Ortofoto VdA (mbtiles)",
                url: "/files/mbtiles/vda-ortofoto-1-17.mbtiles",
                type: "mbtiles-single-file",
                extent: [
                    756122.5583561556413770,
                    5694339.8545881686732173,
                    884815.7731914874166250,
                    5779357.9045197339728475,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },

    {
        id: "pngp-osm-1-18",
        group_required: null,
        type: "mbtiles-single-file",
        title: "OSM PNGP (mbtiles)",
        description: "Mappa OSM PNGP (zoom1-18)",
        icon: "mdi-map",
        downloadTotal: 321734656,
        cached: false,
        status: "cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pngp-osm-1-18",
                title: "OSM PNGP (mbtiles)",
                url: "/files/mbtiles/pngp-osm-1-18.mbtiles",
                type: "mbtiles-single-file",
                extent: [
                    781934.9806508283363655,    // 3857
                    5679667.4050984131172299,
                    848558.3316170207690448,
                    5734497.0189472911879420,
                ],
                minZoom: 1,
                maxZoom: 18,
            }]
    },

    {
        id: "vda-osm-1-17",
        group_required: "ufficio_botanico",
        type: "mbtiles-single-file",
        title: "OSM VdA (mbtiles)",
        description: "Mappa OSM VdA (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 488564736,
        cached: false,
        status: "cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "vda-osm-1-17",
                title: "OSM VdA (mbtiles)",
                url: "/files/mbtiles/vda-osm-1-17.mbtiles",
                type: "mbtiles-single-file",
                extent: [
                    756122.5583561556413770,
                    5694339.8545881686732173,
                    884815.7731914874166250,
                    5779357.9045197339728475,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },


    {
        id: "vda-opentopo-1-17",
        group_required: "ufficio_botanico",
        type: "mbtiles-single-file",
        title: "OpenTopo VdA (mbtiles)",
        description: "Mappa OpenTopo VdA (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 1029420032,
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "vda-opentopo-1-17",
                title: "OpenTopo VdA (mbtiles)",
                url: "/files/mbtiles/vda-opentopo-1-17.mbtiles",
                type: "mbtiles-single-file",
                extent: [
                    756122.5583561556413770,
                    5694339.8545881686732173,
                    884815.7731914874166250,
                    5779357.9045197339728475,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },

    {
        id: "pngp-opentopo-1-17",
        group_required: null,
        type: "mbtiles-single-file",
        title: "OpenTopo PNGP (mbtiles)",
        description: "Mappa OpenTopo PNGP (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 229007360,
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pngp-opentopo-1-17",
                title: "OpenTopo PNGP (mbtiles)",
                url: "/files/mbtiles/pngp-opentopo-1-17.mbtiles",
                type: "mbtiles-single-file",
                extent: [
                    781934.9806508283363655,    // 3857
                    5679667.4050984131172299,
                    848558.3316170207690448,
                    5734497.0189472911879420,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },


    {
        id: "vda-ctr-1-17",
        group_required: "ufficio_botanico",
        type: "mbtiles-single-file",
        title: "CTR VdA (mbtiles)",
        description: "Mappa CTR VdA (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 2481281024,
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "vda-ctr-1-17",
                title: "CTR VdA (mbtiles)",
                url: "/files/mbtiles/vda-ctr-1-17.mbtiles",
                type: "mbtiles-single-file",
                extent: [
                    756122.5583561556413770,
                    5694339.8545881686732173,
                    884815.7731914874166250,
                    5779357.9045197339728475,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },

    {
        id: "pngp-ctr-1-18",
        group_required: null,
        type: "mbtiles-single-file",
        title: "CTR PNGP (mbtiles)",
        description: "Mappa CTR PNGP (zoom1-18)",
        icon: "mdi-map",
        downloadTotal: 415731712,
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pngp-ctr-1-18",
                title: "CTR PNGP (mbtiles)",
                url: "/files/mbtiles/pngp-ctr-1-18.mbtiles",
                type: "mbtiles-single-file",
                extent: [
                    781934.9806508283363655,    // 3857
                    5679667.4050984131172299,
                    848558.3316170207690448,
                    5734497.0189472911879420,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },


    */
    // PMTILES
    //   102941802 May 21 20:14 pngp-ctr-1-18.pmtiles
    //    38074916 May 21 20:14 pngp-opentopo-1-17.pmtiles
    //   610191553 May 21 20:14 pngp-ortofoto-1-17.pmtiles
    //   365462172 May 21 20:15 pngp-osm-1-18.pmtiles
    //  2337957918 May 21 20:16 vda-ctr-1-17.pmtiles
    //   946597212 May 21 20:17 vda-opentopo-1-17.pmtiles
    //  1365815452 May 21 20:18 vda-ortofoto-1-17.pmtiles
    //   379901784 May 21 20:19 vda-osm-1-17.pmtiles

    {
        id: "pmtiles-pngp-ortofoto-1-17",
        group_required: null,
        type: "pmtiles-raster",
        title: "Ortofoto PNGP",
        description: "Mappa ortofoto PNGP (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 610191553,
        cached: false,
        status: "cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pmtiles-pngp-ortofoto-1-17",
                title: "Ortofoto PNGP",
                url: "/files/pmtiles/pngp-ortofoto-1-17.pmtiles",
                type: "pmtiles-raster",
                extent: [
                    781934.9806508283363655,    // 3857
                    5679667.4050984131172299,
                    848558.3316170207690448,
                    5734497.0189472911879420,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },

    {
        id: "pmtiles-vda-ortofoto-1-17",
        group_required: "ufficio_botanico",
        type: "pmtiles-raster",
        title: "Ortofoto VdA",
        description: "Mappa ortofoto VdA (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 1365815452,
        cached: false,
        status: "cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pmtiles-vda-ortofoto-1-17",
                title: "Ortofoto VdA",
                url: "/files/pmtiles/vda-ortofoto-1-17.pmtiles",
                type: "pmtiles-raster",
                extent: [
                    756122.5583561556413770,
                    5694339.8545881686732173,
                    884815.7731914874166250,
                    5779357.9045197339728475,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },

    {
        id: "pmtiles-pngp-osm-1-18",
        group_required: null,
        type: "pmtiles-raster",
        title: "OSM PNGP",
        description: "Mappa OSM PNGP (zoom1-18)",
        icon: "mdi-map",
        downloadTotal: 365462172,
        cached: false,
        status: "cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pmtiles-pngp-osm-1-18",
                title: "OSM PNGP",
                url: "/files/pmtiles/pngp-osm-1-18.pmtiles",
                type: "pmtiles-raster",
                extent: [
                    781934.9806508283363655,    // 3857
                    5679667.4050984131172299,
                    848558.3316170207690448,
                    5734497.0189472911879420,
                ],
                minZoom: 1,
                maxZoom: 18,
            }]
    },

    {
        id: "pmtiles-vda-osm-1-17",
        group_required: "ufficio_botanico",
        type: "pmtiles-raster",
        title: "OSM VdA",
        description: "Mappa OSM VdA (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 379901784,
        cached: false,
        status: "cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pmtiles-vda-osm-1-17",
                title: "OSM VdA",
                url: "/files/pmtiles/vda-osm-1-17.pmtiles",
                type: "pmtiles-raster",
                extent: [
                    756122.5583561556413770,
                    5694339.8545881686732173,
                    884815.7731914874166250,
                    5779357.9045197339728475,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },


    {
        id: "pmtiles-vda-opentopo-1-17",
        group_required: "ufficio_botanico",
        type: "pmtiles-raster",
        title: "OpenTopo VdA",
        description: "Mappa OpenTopo VdA (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 946597212,
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pmtiles-vda-opentopo-1-17",
                title: "OpenTopo VdA",
                url: "/files/pmtiles/vda-opentopo-1-17.pmtiles",
                type: "pmtiles-raster",
                extent: [
                    756122.5583561556413770,
                    5694339.8545881686732173,
                    884815.7731914874166250,
                    5779357.9045197339728475,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },

    {
        id: "pmtiles-pngp-opentopo-1-17",
        group_required: null,
        type: "pmtiles-raster",
        title: "OpenTopo PNGP",
        description: "Mappa OpenTopo PNGP (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 229007360,
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pmtiles-pngp-opentopo-1-17",
                title: "OpenTopo PNGP",
                url: "/files/pmtiles/pngp-opentopo-1-17.pmtiles",
                type: "pmtiles-raster",
                extent: [
                    781934.9806508283363655,    // 3857
                    5679667.4050984131172299,
                    848558.3316170207690448,
                    5734497.0189472911879420,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },


    {
        id: "pmtiles-vda-ctr-1-17",
        group_required: "ufficio_botanico",
        type: "pmtiles-raster",
        title: "CTR VdA",
        description: "Mappa CTR VdA (zoom1-17)",
        icon: "mdi-map",
        downloadTotal: 2481281024,
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pmtiles-vda-ctr-1-17",
                title: "CTR VdA",
                url: "/files/pmtiles/vda-ctr-1-17.pmtiles",
                type: "pmtiles-raster",
                extent: [
                    756122.5583561556413770,
                    5694339.8545881686732173,
                    884815.7731914874166250,
                    5779357.9045197339728475,
                ],
                minZoom: 1,
                maxZoom: 17,
            }]
    },

    {
        id: "pmtiles-pngp-ctr-1-18",
        group_required: null,
        type: "pmtiles-raster",
        title: "CTR PNGP",
        description: "Mappa CTR PNGP (zoom1-18)",
        icon: "mdi-map",
        downloadTotal: 415731712,
        cached: false,
        status: "not-cached", // not-cached, downloading, cached, error, 
        files: [
            {
                id: "pmtiles-pngp-ctr-1-18",
                title: "CTR PNGP",
                url: "/files/pmtiles/pngp-ctr-1-18.pmtiles",
                type: "pmtiles-raster",
                extent: [
                    781934.9806508283363655,    // 3857
                    5679667.4050984131172299,
                    848558.3316170207690448,
                    5734497.0189472911879420,
                ],
                minZoom: 1,
                maxZoom: 18,
            }]
    },




])

if (ENVIRONMENT === "development") {
    filePacks.value = [
        {
            id: "pmtiles-pngp-osm-1-18-test",
            group_required: null,
            type: "pmtiles-raster",
            title: "OSM PNGP TEST",
            description: "Mappa OSM PNGP (zoom1-18) TEST",
            icon: "mdi-map",
            downloadTotal: 365462172,
            cached: false,
            status: "not-cached", // not-cached, downloading, cached, error, 
            files: [
                {
                    id: "pmtiles-pngp-osm-1-18-test",
                    title: "OSM PNGP TEST",
                    url: "/pmtiles-test/pngp-osm-1-18.pmtiles",
                    type: "pmtiles-raster",
                    extent: [
                        781934.9806508283363655,    // 3857
                        5679667.4050984131172299,
                        848558.3316170207690448,
                        5734497.0189472911879420,
                    ],
                    minZoom: 1,
                    maxZoom: 18,
                }]
        },
           {
            id: "pmtiles-pngp-osm-vector-1-18-test",
            group_required: null,
            type: "pmtiles-vector",
            title: "OSM PNGP TEST V",
            description: "Mappa OSM PNGP (zoom1-18) V TEST ",
            icon: "mdi-map",
            downloadTotal: 365462172,
            cached: false,
            status: "not-cached", // not-cached, downloading, cached, error, 
            files: [
                {
                    id: "pmtiles-pngp-osm-vector-1-18-test",
                    title: "OSM PNGP TEST V",
                    url: "/pmtiles-test/pngp.pmtiles",
                    type: "pmtiles-vector",
                    extent: [
                        781934.9806508283363655,
                        5679667.4050984131172299,
                        848558.3316170207690448,
                        5734497.0189472911879420,
                    ],
                    minZoom: 1,
                    maxZoom: 20,
                }]
        },

    ]
}


// if (ENVIRONMENT === "development") {
//     console.log("🧙‍♂️ development mode, adding staging url to filePacks, but CORS problem")
//     for (const pack of filePacks.value) {
//         for (const file of pack.files) {
//             // file.url = "https://picker-staging.pngp.it" + file.url
//             file.url = "/proxystaging" + file.url
//         }

//     }
// }

// exa -1lB


// .rw-r--r--     5312512 mmilone 11 Dec  2023 ol_1-12-vda-pngp-jpg.mbtiles   // test purpose
// .rw-r--r--   415731712 mmilone 12 Jun 10:36 pngp-ctr-1-18.mbtiles
// .rw-r--r--   229007360 mmilone 24 Jan 10:19 pngp-opentopo-1-17.mbtiles
// .rw-r--r--   380482560 mmilone 14 Dec  2023 pngp-ortofoto-1-17.mbtiles
// .rw-r--r--   321734656 mmilone 19 Jan 17:53 pngp-osm-1-18.mbtiles
// .rw-r--r--           101 mmilone 19 Jan 17:51 sqlite-modifications.md
// .rw-r--r-- 2481281024 mmilone 12 Jun 10:35 vda-ctr-1-17.mbtiles
// .rw-r--r-- 1029420032 mmilone 24 Jan 10:18 vda-opentopo-1-17.mbtiles
// .rw-r--r-- 1450550272 mmilone 14 Dec  2023 vda-ortofoto-1-17.mbtiles
// .rw-r--r--   488564736 mmilone 19 Jan 17:53 vda-osm-1-17.mbtiles





// Aggiungere nella MEDIACACHESNEVERDELETE del service worker i filePacks
// In questo modo vengono whitelistati e mai cancellati
// const MEDIACACHESNEVERDELETE = [
//     "filepack-ortofoto_pngp_jpg",
//     "...",
//   ]








// const intervalCheckingFilePacksTree = setInterval(checkFilePacksTree, 5 * 1000)
// console.log("❗️ intervalCheckingFilePacksTree can be redoundant")

// checkFilePacksTree()


export const usePacksStore = defineStore('packsStore', () => {

    const toastsStore = useToastsStore();


    const runtimeStore = useRuntimeStore()

    const isBackgroundFetchSupported = ref(false)

    const useBackgroundFetch = computed(() => {
        if (!isBackgroundFetchSupported) return false
        if (runtimeStore.session.settings?.backgroundFetchUserDisabled) return false
        return true
    })


    let swReg = undefined

    const setSWReg = () => {

        if (typeof swReg === "undefined") {
            navigator?.serviceWorker?.getRegistration().then(async reg => {
                if (reg) {
                    console.log('🧙‍♂️ Service worker is: ', reg);
                    swReg = reg
                    if (swReg?.backgroundFetch) {
                        isBackgroundFetchSupported.value = true
                        console.log("🧙‍♂️ isBackgroundFetchSupported 👍")
                    } else {
                        isBackgroundFetchSupported.value = false
                        console.log("🧙‍♂️ isBackgroundFetchSupported 👎")
                    }
                }
                else {
                    console.log("🫥 No registration of sw")
                    console.log("🧙‍♂️ isBackgroundFetchSupported 👎")
                    swReg = false
                }
            })
        }
    }

    setSWReg()






    const getPack = (id) => {
        return filePacks.value.find((pack) => {
            return pack.id === id
        })
    }


    const markPackCachedFiles = async (pack) => {
        const files = pack.files
        for (const file of files) {
            if (await isUrlCached(file.url)) {
                file.cached = true
                file.status = "cached"
            }

        }
        return true
    }

    const isPackCached = async (pack) => {

        if (typeof caches === "undefined") return false

        const cacheExists = await caches.has("filepack-" + pack.id)


        if (cacheExists)
            console.log("📦 cached " + pack.id)
        else
            console.log("⬛️ missing " + pack.id)

        // console.log("📦 isPackCached", pack, pack.id, cacheExists)
        return cacheExists
        // const files = pack.files

        // for (const file of files) {
        //     const cached = await isUrlCached(file.url)
        //     if (!cached) return false
        // }

        // return true
    }

    const checkFilePacksTree = async () => {

        for (const filePack of filePacks.value) {

            // console.log(filePack.id, filePack.cached)

            markPackCachedFiles(filePack)

            filePack.cached = await isPackCached(filePack)

            // filePack.cached = await isPackCached(filePack)

            if (filePack.cached) {
                filePack.status = "cached"
                continue
            } else {
                filePack.status = "not-cached"
            }

            if (swReg && swReg?.backgroundFetch) {
                let bgFetch = await swReg.backgroundFetch.get(filePack.id)
                if (bgFetch) {
                    console.log("bgFetch", bgFetch)
                    filePack.status = "downloading"
                    continue
                }
                filePack.status = "not-cached"
            }

        }
    }

    const cachedPacks = computed(() => {

        const cachedPacks = filePacks.value.filter((pack) => {
            // console.log(media.cached + " - " + media.url)
            return pack.cached
        })
        return cachedPacks
    })



    const isUrlCached = async (url) => {

        let is_cached = false

        if (typeof caches === "undefined") return is_cached

        const urlEncoded = encodeURI(url)

        await caches.keys().then(async (cacheKeys) => {
            for (const cacheKey of cacheKeys) {
                await caches.open(cacheKey).then(async (cache) => {
                    await cache.match(urlEncoded).then(function (response) {
                        if (response?.status < 300) {
                            // console.log("response is", response)
                            is_cached = true
                        }
                    })
                })
            }
        });

        if (is_cached) {
            // console.log("yes, is cached")
        }

        return is_cached

    }




    //     window.caches.open( myCache )
    //       .then( cache => cache.addAll( content ) )
    //       .then( () => alert( 'content is now available offline' ) )
    //       .catch( () => alert( 'oh noes! something went wrong' ) );


    const downloadPack = async (pack, isActive) => {

        isActive.value = false

        const downloadOptions = {
            title: pack.title,
        }

        if (pack.downloadTotal) {
            console.log("📦 downloadTotal , - enable here!", pack.downloadTotal)
            console.log("📦 downloadTotal set!", pack.downloadTotal)
            downloadOptions.downloadTotal = pack.downloadTotal
        } else {
            console.log("📦 downloadTotal NOT set!")
        }

        toastsStore.toast({
            title: 'Offline data',
            text: 'Scaricamento\n ' + pack.title + '...',
            // type: 'success',
            // duration: 50000
        })

        if (useBackgroundFetch.value) {

            if (!swReg) {
                // console.log("📦 swReg not found, not caching, not downloading")

                toastsStore.toast({
                    title: 'Offline data',
                    text: 'swReg not found, not caching, not downloading',
                    // type: 'success',
                    // duration: 50000
                })
                return false
            }


            console.log("📦 BackgroundFetch Supported")
            console.log("📦 useBackgroundFetch enabled")

            const ids = await swReg.backgroundFetch.getIds()
            console.log(ids)

            if (ids.includes(pack.id)) {
                console.log("📦 already downloading", pack.id)
                return false
            }

            // eslint-disable-next-line
            const bgFetch = await swReg.backgroundFetch.fetch(
                // await swReg.backgroundFetch.fetch(
                pack.id,
                pack.files.map((file) => {
                    return file.url
                }),
                downloadOptions
            );


            // console.log(bgFetch)

            // bgFetch.addEventListener('progress', () => {
            //     console.log("bgFetch progress")

            //     let percent = 0;
            //     if (bgFetch.downloadTotal) {
            //         percent = Math.round(
            //             (bgFetch.downloaded / bgFetch.downloadTotal) * 100,
            //         );
            //     }

            //     const fetchInfo = {
            //         id: bgFetch.id,
            //         percent: percent,
            //         downloadTotal: bgFetch.downloadTotal,
            //         downloaded: bgFetch.downloaded,
            //         failureReason: bgFetch.failureReason,
            //         result: bgFetch.result,
            //     };

            //     // Send a message to the main window
            //     console.log({
            //         type: 'backgroundFetchProgress',
            //         info: fetchInfo
            //     });

            // });

        }

        else {
            console.log("📦 BackgroundFetch NOT enabled, caching normally")


            const fileURLS = pack.files.map((file) => {
                return file.url
            })

            pack.status = "downloading"

            await window.caches.open("filepack-" + pack.id)
                .then(cache => cache.addAll(fileURLS))
                .then(() => {

                    console.log("📦 " + pack.id + 'content is now available offline')

                    pack.status = "cached"

                    checkFilePacksTree()

                    toastsStore.toast({
                        title: 'Offline data',
                        text: 'Scaricato\n ' + pack.title,
                        type: 'success',
                        // duration: 50000
                    })
                })
                .catch((error) => {
                    console.log("❌ " + pack.id + 'oh no! something went wrong')
                    console.log(error)

                    toastsStore.toast({
                        title: 'Offline data',
                        text: 'Errore durante il download di \n ' + pack.title,
                        type: 'error',
                        // duration: 50000
                    })

                    removePack(pack)
                })
        }


        nextTick(() => {
            checkFilePacksTree()
        })

    }

    const removePack = async (pack) => {
        console.log("❌ removePack(pack)")
        await caches.delete("filepack-" + pack.id)
        checkFilePacksTree()
    }


    const stopDownload = async (pack) => {
        console.log("stopDownload")
        console.log(pack.id)

        if (!swReg) {
            console.log("📦 swReg not found, cannot stop")
            return false
        }

        if (swReg && swReg?.backgroundFetch) {
            // navigator.serviceWorker.getRegistration().then(async reg => {

            const ids = await swReg.backgroundFetch.getIds()
            console.log(ids)

            if (!ids.includes(pack.id)) {
                console.log("📦 not downloading, cannot stop", pack.id)
                return false
            }

            const bgFetchInstance = await swReg.backgroundFetch.get(pack.id)
            console.log(bgFetchInstance)
            if (bgFetchInstance) {
                console.log("aborting the download")
                bgFetchInstance.abort()
                checkFilePacksTree()
            }
            else {
                return false
            }

            return true
            // })
        }


        toastsStore.toast({
            title: 'Offline data',
            text: 'Scaricamento interrotto\n' + pack.title,
            // duration: 50000
        })

    }


    const availablePacks = computed(() => {



        return filePacks.value.filter((pack) => {
            if (pack.group_required === null) return true
            if (pack.group_required) {
                if (runtimeStore.session.user.groups.includes(pack.group_required))
                    return true
            }
            return false
        })
    })

    return {
        filePacks,
        availablePacks,
        isBackgroundFetchSupported,
        useBackgroundFetch,
        getPack,
        checkFilePacksTree,
        isPackCached,
        downloadPack,
        removePack,
        stopDownload,

        cachedPacks,

    }
})

